export * from './lib/flash-briefing-feature-shell.module';
